// extracted by mini-css-extract-plugin
export default {"containerOutside":"_2w0UuNgKKPz4VnTYzPFvLD","containerInside":"gcYYXfOrRWl6awUBapiwJ","heading":"_5zK4KwAG2TjlD8iHksERPL"};